export default "__VITE_ASSET__2V3wYENy__"